import { useState } from "react";

export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);

  const phone = "966541138847";
  const message = encodeURIComponent("مرحباً، أريد الاستفسار عن منتجات متجر الإبداع 🎮");
  const whatsappUrl = `https://wa.me/${phone}?text=${message}`;

  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col items-start gap-3" dir="rtl">
      {/* Chat Popup */}
      {open && (
        <div className="bg-[#141414] border border-white/10 rounded-lg overflow-hidden w-72 animate-[fadeInUp_0.3s_ease_both]">
          {/* Header */}
          <div className="bg-[#1a5c38] px-4 py-4 flex items-center gap-3">
            <div className="relative">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
                <img
                  src="https://public.readdy.ai/ai/img_res/3f4c2435-201e-437d-afea-0ab12a1a0054.png"
                  alt="AL Ebdaa"
                  className="w-8 h-8 object-contain"
                />
              </div>
              <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 rounded-full border-2 border-[#1a5c38]"></span>
            </div>
            <div className="flex-1">
              <p className="text-white font-bold text-sm" style={{ fontFamily: "'Cairo', sans-serif" }}>
                متجر الإبداع
              </p>
              <p className="text-green-200 text-xs" style={{ fontFamily: "'Cairo', sans-serif" }}>
                متصل الآن ● يرد خلال دقائق
              </p>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="w-6 h-6 flex items-center justify-center text-white/70 hover:text-white cursor-pointer transition-colors"
            >
              <i className="ri-close-line text-base"></i>
            </button>
          </div>

          {/* Message Bubble */}
          <div className="p-4 bg-[#0f0f0f]">
            <div className="bg-[#1e1e1e] rounded-lg rounded-br-none p-3 max-w-[85%] mr-auto">
              <p className="text-gray-200 text-sm leading-relaxed" style={{ fontFamily: "'Cairo', sans-serif" }}>
                أهلاً وسهلاً! 👋
                <br />
                كيف يمكننا مساعدتك اليوم؟ نحن هنا للإجابة على جميع استفساراتك حول أجهزة الألعاب والإكسسوارات.
              </p>
              <p className="text-gray-600 text-xs mt-1 text-left">الآن</p>
            </div>
          </div>

          {/* CTA */}
          <div className="p-4 border-t border-white/5">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20bc5a] text-white font-bold py-3 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Cairo', sans-serif" }}
            >
              <i className="ri-whatsapp-fill text-lg"></i>
              ابدأ المحادثة على واتساب
            </a>
          </div>
        </div>
      )}

      {/* Floating Button */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="relative w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#20bc5a] rounded-full cursor-pointer transition-all duration-300 hover:scale-110"
        aria-label="تواصل عبر واتساب"
      >
        <i className={`text-white text-2xl transition-all duration-200 ${open ? "ri-close-line" : "ri-whatsapp-fill"}`}></i>
        {/* Ping animation */}
        {!open && (
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40"></span>
        )}
        {/* Tooltip */}
        {!open && (
          <span
            className="absolute left-16 bg-[#141414] border border-white/10 text-white text-xs px-3 py-1 rounded-full whitespace-nowrap pointer-events-none opacity-0 group-hover:opacity-100"
            style={{ fontFamily: "'Cairo', sans-serif" }}
          >
            تواصل معنا
          </span>
        )}
      </button>
    </div>
  );
}
